export const whitelist_arr = ["AccessToken", "persistSlice"];

export default whitelist_arr;
